module.exports = __webpack_public_path__ + "img/pg.c7c64153.svg";